<template>
    <v-card
        v-if="productTierPrices"
        v-show="productTierPrices.length > 0"
        class="product-tier-prices-box"
        :width="unitWidth"
        :max-width="unitWidth"
        :style="tierPriceStyle"
        v-observe-visibility="visibilityChanged"
    >
        <div
            v-for="{ tierPrice, quantity } of productTierPrices"
            :key="`tier-price-${quantity}`"
            class="font-weight-bold tier-price-text-wrap"
            :class="{ caption: $vuetify.breakpoint.smAndDown }"
            :style="{ height: unitHeight + 'px' }"
        >
            <div
                class="tier-price-text pa-1"
                ref="tierPriceText"
                :class="$vuetify.breakpoint.smAndDown ? 'tier-price-text-mobile' : ''"
            >
                {{ 'Buy' | translation }}
                {{ quantity }}
                {{ 'for' | translation }}
                {{ tierPrice | currency }}/{{ 'piece' | translation }}
                {{ 'and save' | translation }}
                {{ productSavePrice(tierPrice) }}%
            </div>
        </div>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { loadProducts } from '@breakmedia/prime-vue-product/src/store/getProducts';

export default {
    props: {
        product: Object,
        productId: {
            type: [Number, String],
        },
        merchant: {
            type: [Number, String],
        },
        arrowOnBottom: Boolean,
        heigth: Number,
        width: Number,
        quantityInBasket: String | Number,
    },
    data() {
        return {
            unitHeight: 0,
            unitWidth: 0,
            productTierPrices: [],
        };
    },
    computed: {
        ...mapGetters(['getTransparentColor']),
        ...mapGetters('Product', ['tierPrices', 'price']),
        color() {
            return `${this.$vuetify.theme.primary}7f`;
        },
        tierPriceStyle() {
            let marginTop = undefined;
            if (this.arrowOnBottom && !this.$vuetify.breakpoint.mdAndUp) {
                marginTop = `${this.unitHeight}px`;
            }
            return {
                borderColor: `${this.getTransparentColor(this.$vuetify.theme.primary)} !important`,
                border: `3px solid ${this.getTransparentColor(this.$vuetify.theme.primary)}`,
                borderRadius: '3px',
                marginTop: marginTop,
            };
        },
        coefficient() {
            let coefficient = 0;
            if (this.arrowOnBottom && !this.$vuetify.breakpoint.mdAndUp) {
                coefficient = this.unitHeight;
            }
            return coefficient;
        },
    },
    methods: {
        productSavePrice(price) {
            return Math.round(100 - (price * 100) / this.price(this.product, this.productId, this.merchant));
        },
        updateHeight() {
            this.$emit('update:height', this.productTierPrices.length * this.unitHeight + this.coefficient);
        },
        visibilityChanged(isVisible) {
            if (isVisible) {
                this.calculateUnitHeight();
            }
        },
        calculateUnitHeight() {
            if (this.$refs.tierPriceText) {
                if (Array.isArray(this.$refs.tierPriceText)) {
                    this.unitHeight = this.$refs.tierPriceText[0].offsetHeight;
                    let width = 0;
                    this.$refs.tierPriceText.forEach(node => {
                        if (node.clientWidth > width) {
                            width = node.clientWidth + 5;
                        }
                    });
                    this.unitWidth = width;
                } else {
                    this.unitHeight = this.$refs.tierPriceText.offsetHeight;
                    this.unitWidth = this.$refs.tierPriceText.offsetWidth + 5;
                }
            }
        },
        loadTierPrices() {
            const tierPrices = this.tierPrices(this.product, this.productId, this.merchant) || [];
            const promises = [];
            for (const quantity of tierPrices) {
                if (!this.quantityInBasket || this.quantityInBasket < quantity) {
                    const priceParams = [];
                    priceParams.push({
                        country: this.$country.getCountryID(),
                        merchant: this.merchant,
                        quantity: {
                            [this.productId]: quantity,
                        },
                        currency: this.$currency.getSelected(),
                    });
                    promises.push(
                        loadProducts({
                            ids: [this.productId],
                            fields: 'id price merchant {id price}',
                            priceParams: priceParams,
                        }).then(products => {
                            const product = products[0];
                            let price;
                            if (product.id == this.productId) {
                                price = product.price.price;
                            } else {
                                price = product.merchant[this.merchant].price[this.productId].price;
                            }
                            return {
                                quantity,
                                tierPrice: price,
                            };
                        }),
                    );
                }
            }
            Promise.all(promises).then(productTierPrices => {
                this.productTierPrices = productTierPrices || [];
            });
        },
    },
    watch: {
        productTierPrices: {
            immediate: true,
            handler() {
                this.updateHeight();
            },
        },
        unitHeight: {
            immediate: true,
            handler() {
                this.updateHeight();
            },
        },
        unitWidth: {
            immediate: true,
            handler(val) {
                this.$emit('update:width', val);
            },
        },
        quantityInBasket: {
            immediate: true,
            handler() {
                this.loadTierPrices();
            },
        },
        productId: {
            immediate: true,
            handler() {
                this.loadTierPrices();
            },
        },
    },
};
</script>

<style scoped>
.top-arrow {
    position: absolute;
    margin-top: -35px;
    margin-left: 45px;
}
.bottom-arrow {
    position: absolute;
    margin-left: 270px;
}

.tier-price-text-wrap {
    position: relative;
}

.tier-price-text {
    position: absolute;
    white-space: nowrap;
    top: 0;
    left: 0;
}

.tier-price-text-mobile {
    font-size: 13px;
}
</style>
